// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9777) return "static/chunks/recorder.4d74e3253d2538b8.js";
	if (chunkId === 12) return "static/chunks/profiler.cde8eb583d3276a2.js";
	if (chunkId === 456) return "static/chunks/456.0a15b14796b0f5f9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2186":"301ca88919ce1e75","2402":"cbab10b109640a23","4172":"5601581d5ad570dd","5951":"3425f44c0e40d579","9944":"167eb5a3b288f3b8"}[chunkId] + ".js";
};